import { camelCase as esToolKitCamelCase, isPlainObject, isString } from 'es-toolkit';
import { isEmpty } from 'es-toolkit/compat';
import { hlsMediaFormatMap, mediaFormats } from './constants';
export function toHttps(url) {
    return url ? url.replace('http://', 'https://') : '';
}
export function getMediaFormat(playlistType, mediaType) {
    if (playlistType?.toLowerCase() === mediaFormats.pls) {
        return mediaFormats.pls;
    }
    const lowerCaseMediaType = mediaType?.toLowerCase() || '';
    return hlsMediaFormatMap[lowerCaseMediaType] || lowerCaseMediaType;
}
function handleObject(obj) {
    const newObj = {};
    for (const key in obj) {
        const val = obj[key];
        newObj[esToolKitCamelCase(key)] = camelCaseKeys(val);
    }
    return newObj;
}
function camelCaseKeys(value) {
    if (Array.isArray(value)) {
        return value.map(camelCaseKeys);
    }
    if (isPlainObject(value)) {
        return handleObject(value);
    }
    return value;
}
export function camelCase(data) {
    if (isEmpty(data) || isString(data)) {
        return data;
    }
    if (Array.isArray(data)) {
        return data.map((obj) => camelCaseKeys(obj));
    }
    return camelCaseKeys(data);
}
